<template>
  <transition name="el-fade-in-linear">
    <div
      class="onboarding-container bg-light w-100 h-100 min-vh-100 d-flex flex-column position-absolute fixed-top z-index-master"
      style="background-color: #f8f9fa; z-index: 3000;">
      <!-- HEADER -->
      <div
        class="onboarding-header d-flex justify-content-between align-items-center bg-white px-4 py-3 border-bottom shadow-sm">
        <div class="logo d-flex align-items-center">
          <img style="width: 32px; height: 32px; margin-right: 8px;" src="@/assets/logo.png" />
          <a href="/" style="color: #373C41; font-size: 16px; font-weight: 600; line-height: 20px; letter-spacing: 0.14px; text-decoration: none; white-space: nowrap;">Salework <span style="color: #479a5e">Contact</span></a>
        </div>
        <div>
          <el-button plain size="small" style="color: #6b7280; font-weight: 500;" @click="skipOnboarding">Bỏ qua, tôi sẽ
            tự thiết lập sau</el-button>
        </div>
      </div>

      <div class="flex-grow-1 d-flex flex-column align-items-center pt-3 pb-3 overflow-auto">
        <!-- STEPPER -->
        <div style="width: 600px; margin-bottom: 16px;">
          <div class="d-flex justify-content-between position-relative">
            <div class="position-absolute"
              style="top: 16px; left: 16%; right: 16%; height: 2px; background-color: #e5e7eb; z-index: 1;"></div>
            <!-- Dynamic progress line -->
            <div class="position-absolute"
              :style="{ top: '16px', left: '16%', right: (100 - 16 - (currentStep - 1) * 34) + '%', height: '2px', backgroundColor: '#10b981', zIndex: 2, transition: 'all 0.3s ease' }">
            </div>

            <!-- Step 1 -->
            <div class="d-flex flex-column align-items-center position-relative" style="z-index: 3; width: 33%;">
              <div class="step-circle mb-2 d-flex justify-content-center align-items-center text-white fw-bold"
                :style="{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: currentStep >= 1 ? (currentStep > 1 ? '#10b981' : '#2563eb') : '#d1d5db', transition: 'all 0.3s ease' }">
                <i v-if="currentStep > 1" class="el-icon-check"></i>
                <span v-else>1</span>
              </div>
              <span class="fw-bold" style="font-size: 13px;"
                :style="{ color: currentStep >= 1 ? (currentStep > 1 ? '#10b981' : '#2563eb') : '#6b7280' }">Ngành
                nghề</span>
            </div>

            <!-- Step 2 -->
            <div class="d-flex flex-column align-items-center position-relative" style="z-index: 3; width: 33%;">
              <div class="step-circle mb-2 d-flex justify-content-center align-items-center text-white fw-bold"
                :style="{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: currentStep >= 2 ? (currentStep > 2 ? '#10b981' : '#2563eb') : '#d1d5db', transition: 'all 0.3s ease' }">
                <i v-if="currentStep > 2" class="el-icon-check"></i>
                <span v-else>2</span>
              </div>
              <span class="fw-bold" style="font-size: 13px;"
                :style="{ color: currentStep >= 2 ? (currentStep > 2 ? '#10b981' : '#2563eb') : '#6b7280' }">Trường dữ
                liệu</span>
            </div>

            <!-- Step 3 -->
            <div class="d-flex flex-column align-items-center position-relative" style="z-index: 3; width: 33%;">
              <div class="step-circle mb-2 d-flex justify-content-center align-items-center text-white fw-bold"
                :style="{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: currentStep >= 3 ? '#2563eb' : '#d1d5db', transition: 'all 0.3s ease' }">
                <span>3</span>
              </div>
              <span class="fw-bold" style="font-size: 13px;"
                :style="{ color: currentStep >= 3 ? '#2563eb' : '#6b7280' }">Quy trình</span>
            </div>
          </div>
        </div>

        <!-- MAIN CARD -->
        <div class="bg-white rounded-3 shadow-sm border onboarding-card"
          :style="{
            width: '1200px',
            maxWidth: 'calc(100vw - 80px)',
            minHeight: '0',
            maxHeight: 'calc(100vh - 160px)',
            padding: '24px 32px 12px 32px',
            display: 'flex',
            flexDirection: 'column',
            flexShrink: 0,
            overflow: 'hidden'
          }">
          <transition name="fade-slide" mode="out-in">
            <!-- STEP 1: NGÀNH NGHỀ -->
            <div v-if="currentStep === 1" key="step1" class="flex-grow-1 d-flex flex-column" style="min-height: 0;">
              <div class="mb-3">
                <div class="text-primary fw-bold mb-2"
                  style="font-size: 11px; letter-spacing: 1px; background: #eff6ff; display: inline-block; padding: 4px 8px; border-radius: 4px;">
                  BƯỚC 1 / 3</div>
                <h2 class="fw-bold mb-1" style="font-size: 22px; color: #111827;">Doanh nghiệp bạn thuộc ngành nào?</h2>
                <p class="text-muted mb-0" style="font-size: 13px;">Thông tin này giúp AI Insight hiểu bối cảnh kinh doanh
                  của bạn. Không ảnh hưởng đến cấu hình hệ thống — bạn hoàn toàn tự do thiết lập theo nhu cầu.</p>
              </div>

              <div v-if="loadingIndustries" class="text-center py-5 text-muted">
                <i class="el-icon-loading" style="font-size: 24px;"></i>
                <div class="mt-2" style="font-size: 13px;">Đang tải danh sách ngành nghề...</div>
              </div>
              <div v-else class="industry-grid-scroll mb-4 pe-2">
                <div class="row g-3">
                  <div v-for="(industry, index) in industries" :key="industry.code || index" class="col-3">
                    <div
                      class="industry-card h-100 p-3 border rounded text-center cursor-pointer position-relative flex-column d-flex align-items-center justify-content-center"
                      :class="{ 'selected': selectedIndustry === industry.code }" @click="selectedIndustry = industry.code"
                      style="min-height: 120px; transition: all 0.2s ease;">
                      <div v-if="selectedIndustry === industry.code" class="position-absolute"
                        style="top: 8px; right: 8px; color: #2563eb;"><i class="el-icon-success fw-bold fs-5"></i></div>
                      <div class="icon-box mb-2 d-flex justify-content-center align-items-center rounded-2"
                        :style="{ width: '40px', height: '40px', backgroundColor: industryStyle(industry).bg, color: industryStyle(industry).color }">
                        <i :class="industryStyle(industry).icon" style="font-size: 20px;"></i>
                      </div>
                      <div class="fw-bold text-dark" style="font-size: 14px;">{{ industry.display || industry.name }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="step-footer mt-auto d-flex justify-content-between align-items-center pt-3 border-top">
                <div class="text-muted" style="font-size: 13px;">Đã chọn: <span class="fw-bold text-dark">{{
                  selectedIndustryName || 'Chưa chọn' }}</span></div>
                <el-button type="primary" :disabled="!selectedIndustry || savingIndustry" :loading="savingIndustry"
                  @click="nextStep" style="border-radius: 6px; padding: 10px 32px; font-weight: bold;">Tiếp tục <i
                    class="el-icon-arrow-right ms-1"></i></el-button>
              </div>
            </div>

            <!-- STEP 2: TRƯỜNG DỮ LIỆU -->
            <div v-else-if="currentStep === 2" key="step2" class="flex-grow-1 d-flex flex-column" style="min-height: 0;">
              <div class="mb-4">
                <div class="text-primary fw-bold mb-2"
                  style="font-size: 11px; letter-spacing: 1px; background: #eff6ff; display: inline-block; padding: 4px 8px; border-radius: 4px;">
                  BƯỚC 2 / 3</div>
                <h2 class="fw-bold mb-2" style="font-size: 24px; color: #111827;">Xác nhận trường dữ liệu</h2>
                <p class="text-muted" style="font-size: 14px;">Hệ thống đã có sẵn <strong>5 trường mặc định</strong>. AI đã gợi ý thêm trường phù hợp với ngành — hãy chọn những trường bạn muốn thêm, hoặc tự tạo trường riêng.</p>
              </div>

              <div class="onboarding-two-col flex-grow-1 pb-3">
              <!-- AI suggestion banner -->
              <div v-if="showSuggestionBanner" class="ai-suggestion-banner rounded p-3 col-left">
                <div class="d-flex align-items-center mb-2">
                  <div class="d-flex justify-content-center align-items-center rounded me-2"
                    style="width: 28px; height: 28px; background: #e0e7ff; color: #4f46e5;">
                    <i class="el-icon-star-off" style="font-size: 16px;"></i>
                  </div>
                  <div>
                    <div class="fw-bold" style="font-size: 14px; color: #1e3a8a;">AI gợi ý trường dữ liệu</div>
                    <div class="text-muted" style="font-size: 12px;">Dựa trên ngành: <span class="fw-bold text-dark">{{ selectedIndustryName }}</span></div>
                  </div>
                </div>

                <div v-if="loadingSuggestions" class="text-center py-4 text-muted">
                  <i class="el-icon-loading" style="font-size: 20px;"></i>
                  <div class="mt-1" style="font-size: 12px;">AI đang phân tích ngành nghề để gợi ý trường phù hợp...</div>
                </div>

                <template v-else-if="suggestedFields.length">
                  <div class="text-muted mb-2" style="font-size: 11px; letter-spacing: 0.5px;">
                    <i class="el-icon-star-off"></i> NHẤN VÀO TRƯỜNG ĐỂ THÊM
                  </div>
                  <div class="field-suggestions-scroll">
                    <div class="d-flex flex-wrap mb-2" style="gap: 8px;">
                      <div v-for="(sf, idx) in suggestedFields" :key="idx"
                        class="suggestion-chip"
                        :class="{ 'added': isFieldAdded(sf) }"
                        @click="!isFieldAdded(sf) && openFieldFromSuggestion(sf)">
                        <i :class="isFieldAdded(sf) ? 'el-icon-check' : 'el-icon-plus'" class="me-1"></i>
                        <span>{{ sf.name }}</span>
                        <span class="chip-type ms-1">({{ sf.typeLabel }})</span>
                        <span v-if="isFieldAdded(sf)" class="ms-2 chip-badge">Đã thêm</span>
                      </div>
                    </div>
                  </div>
                </template>

                <div v-else class="text-center py-3 text-muted" style="font-size: 12px;">
                  Không có gợi ý cho ngành này.
                </div>
              </div>

              <div class="col-right d-flex flex-column">
              <!-- Field tabs -->
              <div class="field-tabs d-flex mb-2" style="gap: 6px;">
                <button v-for="tab in fieldTabs" :key="tab.key"
                  type="button" class="field-tab"
                  :class="{ active: currentFieldTab === tab.key }"
                  @click="currentFieldTab = tab.key">
                  {{ tab.label }} <span class="field-tab-count">{{ tab.count }}</span>
                </button>
              </div>

              <div class="fields-container bg-light rounded p-3 border">
                <div class="fields-list-scroll">
                  <div v-for="field in filteredFields" :key="field.key"
                    class="d-flex justify-content-between align-items-center py-2 border-bottom">
                    <div class="d-flex align-items-center">
                      <div class="field-check me-3" :class="`check-${field.source}`">
                        <i class="el-icon-check"></i>
                      </div>
                      <span class="fw-bold text-dark" style="font-size: 14px;">{{ field.name }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="type-pill me-2">{{ field.type }}</span>
                      <span class="source-pill" :class="sourcePillClass(field)">
                        {{ field.tag }}
                      </span>
                      <el-button v-if="field.source !== 'default'" type="text" size="mini"
                        class="ms-2 p-0" :loading="deletingFieldId === field.id"
                        @click="removeField(field)">
                        <i class="el-icon-delete" style="font-size: 14px; color: #dc2626;"></i>
                      </el-button>
                    </div>
                  </div>
                  <div v-if="!filteredFields.length" class="text-center text-muted py-3" style="font-size: 12px;">
                    Chưa có trường nào trong mục này.
                  </div>
                </div>

                <div class="mt-3">
                  <el-button plain class="w-100 text-primary fw-bold hover-light"
                    style="border-style: dashed; border-color: #93c5fd; background-color: #eff6ff; padding: 12px;"
                    @click="openCreateFieldDialog">
                    <i class="el-icon-plus me-1"></i> Thêm trường mới
                  </el-button>
                </div>
              </div>

              </div>
              </div>

              <div class="step-footer mt-auto d-flex justify-content-between align-items-center pt-3 border-top">
                <div class="text-muted" style="font-size: 13px;">{{ defaultFieldCount }} trường mặc định + {{ aiFieldCount + manualFieldCount }} trường
                  mới</div>
                <div>
                  <el-button plain style="border-radius: 6px; padding: 10px 20px;" @click="prevStep"><i
                      class="el-icon-arrow-left me-1"></i> Quay lại</el-button>
                  <el-button type="primary" @click="nextStep"
                    style="border-radius: 6px; padding: 10px 32px; font-weight: bold;">Tiếp tục <i
                      class="el-icon-arrow-right ms-1"></i></el-button>
                </div>
              </div>
            </div>

            <!-- STEP 3: QUY TRÌNH -->
            <div v-else-if="currentStep === 3" key="step3" class="flex-grow-1 d-flex flex-column" style="min-height: 0;">
              <div class="mb-4">
                <div class="text-primary fw-bold mb-2"
                  style="font-size: 11px; letter-spacing: 1px; background: #eff6ff; display: inline-block; padding: 4px 8px; border-radius: 4px;">
                  BƯỚC 3 / 3</div>
                <h2 class="fw-bold mb-2" style="font-size: 24px; color: #111827;">Xác nhận quy trình bán hàng</h2>
                <p class="text-muted" style="font-size: 14px;">Hệ thống đã tạo sẵn quy trình mặc định với 5 bước tổng
                  quát.</p>
              </div>

              <div class="onboarding-two-col flex-grow-1 pb-3">
              <!-- AI process suggestion banner -->
              <div v-if="showProcessSuggestionBanner" class="ai-suggestion-banner rounded p-3 col-left">
                <div class="d-flex align-items-center mb-2">
                  <div class="d-flex justify-content-center align-items-center rounded me-2"
                    style="width: 28px; height: 28px; background: #e0e7ff; color: #4f46e5;">
                    <i class="el-icon-star-off" style="font-size: 16px;"></i>
                  </div>
                  <div>
                    <div class="fw-bold" style="font-size: 14px; color: #1e3a8a;">AI gợi ý quy trình bán hàng</div>
                    <div class="text-muted" style="font-size: 12px;">Dựa trên ngành: <span class="fw-bold text-dark">{{ selectedIndustryName }}</span></div>
                  </div>
                </div>

                <div v-if="loadingProcessSuggestions" class="text-center py-4 text-muted">
                  <i class="el-icon-loading" style="font-size: 20px;"></i>
                  <div class="mt-1" style="font-size: 12px;">AI đang phân tích để gợi ý quy trình phù hợp...</div>
                </div>

                <template v-else-if="suggestedProcesses.length">
                  <div class="text-muted mb-2" style="font-size: 11px; letter-spacing: 0.5px;">
                    <i class="el-icon-star-off"></i> NHẤN VÀO QUY TRÌNH ĐỂ THÊM
                  </div>
                  <div class="d-flex flex-column process-suggestions-list" style="gap: 8px;">
                    <div v-for="(proc, idx) in suggestedProcesses" :key="idx"
                      class="process-suggestion-card"
                      :class="{ added: isProcessAdded(proc) }"
                      @click="!isProcessAdded(proc) && openProcessFromSuggestion(proc)">

                      <div class="d-flex align-items-center mb-1">
                        <i :class="isProcessAdded(proc) ? 'el-icon-check' : 'el-icon-plus'" class="me-2"></i>
                        <span class="fw-bold" style="font-size: 13px;">{{ proc.processName }}</span>
                        <span v-if="isProcessAdded(proc)" class="ms-2 chip-badge">Đã thêm</span>
                      </div>
                      <p v-if="proc.processDescription" class="text-muted mb-2" style="font-size: 12px;">{{ proc.processDescription }}</p>

                      <div class="d-flex flex-wrap align-items-center" style="gap: 4px;">
                        <template v-for="(step, sIdx) in proc.workflowDTOS">
                          <span :key="sIdx" class="process-step"
                            :class="{ success: step.milestoneType === 'WON', danger: step.milestoneType === 'LOST' }"
                            style="font-size: 11px; padding: 3px 8px;">{{ step.title }}</span>
                          <i v-if="sIdx < proc.workflowDTOS.length - 1" :key="`a-${sIdx}`"
                            class="el-icon-right text-muted" style="font-size: 11px;"></i>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>

                <div v-else class="text-center py-3 text-muted" style="font-size: 12px;">
                  Không có gợi ý cho ngành này.
                </div>
              </div>

              <div class="col-right d-flex flex-column">
              <!-- Process tabs -->
              <div class="field-tabs d-flex mb-2" style="gap: 6px;">
                <button v-for="tab in processTabs" :key="tab.key"
                  type="button" class="field-tab"
                  :class="{ active: currentProcessTab === tab.key }"
                  @click="currentProcessTab = tab.key">
                  {{ tab.label }} <span class="field-tab-count">{{ tab.count }}</span>
                </button>
              </div>

              <div class="process-list-scroll mb-3">
              <div v-if="defaultProcess && currentProcessTab === 'all'"
                class="process-card border rounded p-4 mb-3 position-relative cursor-pointer hover-shadow"
                style="background-color: #eff6ff; border-color: #93c5fd !important;"
                @click="openEditProcess(defaultProcess)">
                <div class="position-absolute" style="top: 16px; right: 16px; color: #3b82f6;"><i
                    class="el-icon-success fw-bold fs-4"></i></div>
                <h5 class="fw-bold" style="color: #1e3a8a; font-size: 16px;">{{ defaultProcess.name }} <i
                    class="el-icon-edit-outline ms-2 text-primary" style="font-size: 14px;"></i></h5>
                <p class="text-muted mb-3" style="font-size: 13px;">Phù hợp với mọi ngành nghề. Bạn có thể đổi tên bước,
                  thêm/xoá bước sau trong phần Thiết lập.</p>

                <div class="d-flex align-items-center flex-wrap mb-2">
                  <template v-for="(step, idx) in defaultProcess.workflowList">
                    <span :key="idx" class="process-step mb-2"
                      :class="{ 'success': step.milestoneType === 'WON', 'danger': step.milestoneType === 'LOST' }">{{
                      step.title }}</span>
                    <i v-if="idx < defaultProcess.workflowList.length - 1"
                      :key="`i-${idx}`" class="el-icon-right text-muted mx-2 mb-2" style="font-size: 14px;"></i>
                    <!-- <span v-if="idx < defaultProcess.workflowList.length - 1 && step.milestoneType === 'WON'"
                      :key="`sep-${idx}`" class="mx-2 text-muted fw-bold mb-2" style="font-size: 14px;">/</span> -->
                  </template>
                </div>

                <div class="d-flex align-items-center mt-4 pt-1" style="font-size: 11px;">
                  <span class="d-flex align-items-center me-3 text-muted">
                    <div class="rounded-sm me-1" style="width:10px;height:10px;background:#e1edfd;border:1px solid #85b1ff;"></div> Đang xử lý
                  </span>
                  <span class="d-flex align-items-center me-3 text-muted">
                    <div class="rounded-sm me-1" style="width:10px;height:10px;background:#e6f7eb;border:1px solid #5bb974;"></div> Thành công
                  </span>
                  <span class="d-flex align-items-center text-muted">
                    <div class="rounded-sm me-1" style="width:10px;height:10px;background:#ffeced;border:1px solid #f28b82;"></div> Thất bại
                  </span>
                </div>
              </div>

              <!-- Other processes (created in-session or already in DB from AI/manual) -->
              <div v-for="proc in filteredOtherProcesses" :key="`p-${proc.id}`"
                class="process-card border rounded p-4 mb-3 position-relative cursor-pointer hover-shadow"
                style="background-color: #f8fafc; border-color: #cbd5e1 !important;"
                @click="openEditProcess(proc)">
                <div class="position-absolute" style="top: 16px; right: 16px; color: #2563eb;"><i
                    class="el-icon-success fw-bold fs-4"></i></div>
                <h5 class="fw-bold" style="color: #1e293b; font-size: 16px;">{{ proc.name }} <i
                    class="el-icon-edit-outline ms-2 text-primary" style="font-size: 14px;"></i></h5>
                <p class="text-muted mb-3" style="font-size: 13px;">{{ proc.description || 'Quy trình mới thiết lập' }}</p>

                <div class="d-flex align-items-center flex-wrap mb-2">
                  <template v-for="(step, sIdx) in (proc.workflowList || [])">
                    <span :key="`s-${sIdx}`" class="process-step mb-2"
                      :class="{ 'success': step.milestoneType === 'WON', 'danger': step.milestoneType === 'LOST' }">{{ step.title }}</span>
                    <i v-if="sIdx < proc.workflowList.length - 1" :key="`i-${sIdx}`"
                      class="el-icon-right text-muted mx-2 mb-2" style="font-size: 14px;"></i>
                  </template>
                </div>
              </div>

              </div>

              <div class="mb-4">
                <el-button plain class="w-100 text-primary fw-bold hover-light"
                  style="border-style: dashed; border-color: #93c5fd; background-color: #fafafa; padding: 12px;"
                  @click="openCreateProcessDialog">
                  <i class="el-icon-plus me-1"></i> Thêm quy trình mới
                </el-button>
              </div>

              <div class="p-3 rounded mb-4" style="background-color: #f3f4f6;">
                <p class="mb-0 text-muted" style="font-size: 13px;">
                  <span class="fw-bold text-dark">Lưu ý:</span> Bạn có thể tuỳ chỉnh quy trình bất cứ lúc nào trong
                  <span class="fw-bold text-dark">Thiết lập > Thiết lập quy trình</span>. Cũng có thể tạo thêm nhiều quy
                  trình cho các
                  nhóm khách hàng khác nhau.
                </p>
              </div>
              </div>
              </div>

              <div class="step-footer mt-auto d-flex justify-content-between align-items-center pt-3 border-top">
                <div class="text-muted" style="font-size: 13px;">Quy trình mặc định: 5 bước + {{ otherProcesses.length
                  }} quy trình
                  mới</div>
                <div>
                  <el-button plain style="border-radius: 6px; padding: 10px 20px;" @click="prevStep"><i
                      class="el-icon-arrow-left me-1"></i> Quay lại</el-button>
                  <el-button type="success" @click="finishSetup"
                    style="border-radius: 6px; padding: 10px 24px; background-color: #10b981; border-color: #10b981; font-weight: bold;"><i
                      class="el-icon-check me-1"></i> Hoàn tất thiết lập</el-button>
                </div>
              </div>
            </div>
          </transition>

        </div>
      </div>
      <DialogCreateField v-if="showFieldDialog" ref="dialogCreateField" :codeRemain="codeRemain"
        :initial="pendingFieldInitial"
        :appendToBody="false" @close="closeFieldDialog" @field-added="handleFieldDialogClose" />
      <DialogCreateProcess v-if="showProcessDialog" ref="dialogCreateProcess"
        :initial="pendingProcessInitial"
        :appendToBody="false" @close="closeProcessDialog" @success="handleProcessDialogClose" />
      <DialogUpdateProcess v-if="showUpdateProcessDialog" :formData="editingProcess || defaultProcess"
        :appendToBody="false" @close="closeUpdateProcessDialog" @success="handleUpdateDefaultSuccess" />

      <el-dialog :visible.sync="showSuccessDialog" width="450px" :show-close="false" :close-on-click-modal="false"
        :close-on-press-escape="false" :modal-append-to-body="false" custom-class="success-modal onboarding-success">
        <div class="text-center pb-3 pt-2">
          <div class="mx-auto mb-4 d-flex justify-content-center align-items-center rounded-circle"
            style="width: 68px; height: 68px; background-color: #d1fae5;">
            <i class="el-icon-check text-success" style="font-size: 36px; font-weight: bold;"></i>
          </div>
          <h2 class="fw-bold mb-3" style="font-size: 22px; color: #111827;">Thiết lập hoàn tất!</h2>
          <p class="text-muted mb-4" style="font-size: 15px; line-height: 1.5; padding: 0 10px;">
            Hệ thống đã sẵn sàng.
            <template v-if="isAdmin">Dashboard sẽ hiển thị dữ liệu khi bạn bắt đầu thêm khách hàng.</template>
            <template v-else>Nhân viên có thể bắt đầu làm việc với khách hàng.</template>
          </p>
          <el-button type="primary" size="large" class="w-100 fw-bold"
            style="background-color: #2563eb; border-radius: 8px; font-size: 15px; padding: 14px;"
            @click="goToDestination">
            {{ isAdmin ? 'Vào Dashboard' : 'Bắt đầu làm việc' }}
            <span v-if="countdown > 0" style="font-weight: 400; opacity: 0.8;"> ({{ countdown }}s)</span>
          </el-button>
        </div>
      </el-dialog>
    </div>
  </transition>
</template>

<script>
import DialogCreateField from "@/components/Setting/DialogCreateField.vue";
import DialogCreateProcess from "@/components/Setting/DialogCreateProcess.vue";
import DialogUpdateProcess from "@/components/Setting/DialogUpdateProcess.vue";
import { HTTP } from "@/lib/http-common";
import field from "@/lib/apis/field";

const INDUSTRY_ICON_MAP = [
  { keys: ['thời trang', 'phụ kiện', 'fashion'], icon: 'el-icon-shopping-bag-1', bg: '#fce7f3', color: '#db2777' },
  { keys: ['làm đẹp', 'spa', 'clinic', 'beauty'], icon: 'el-icon-magic-stick', bg: '#fde2e8', color: '#e11d48' },
  { keys: ['f&b', 'ăn uống', 'nhà hàng', 'cafe', 'food'], icon: 'el-icon-food', bg: '#fff7ed', color: '#ea580c' },
  { keys: ['giáo dục', 'khoá học', 'khoa hoc', 'education'], icon: 'el-icon-reading', bg: '#fef3c7', color: '#d97706' },
  { keys: ['bất động sản', 'real estate'], icon: 'el-icon-office-building', bg: '#e0e7ff', color: '#4f46e5' },
  { keys: ['ô tô', 'xe máy', 'gara', 'auto'], icon: 'el-icon-truck', bg: '#e5e7eb', color: '#4b5563' },
  { keys: ['điện tử', 'gia dụng', 'electronics'], icon: 'el-icon-mobile-phone', bg: '#dbeafe', color: '#2563eb' },
  { keys: ['công nghệ', 'phần mềm', 'saas', 'tech', 'software'], icon: 'el-icon-cpu', bg: '#ede9fe', color: '#6d28d9' },
  { keys: ['y tế', 'phòng khám', 'nhà thuốc', 'health', 'medical'], icon: 'el-icon-first-aid-kit', bg: '#fee2e2', color: '#dc2626' },
  { keys: ['gym', 'fitness', 'yoga'], icon: 'el-icon-basketball', bg: '#dcfce7', color: '#16a34a' },
  { keys: ['nội thất', 'trang trí', 'furniture'], icon: 'el-icon-house', bg: '#f5f3ff', color: '#7c3aed' },
  { keys: ['trang sức', 'đồng hồ', 'jewelry'], icon: 'el-icon-medal', bg: '#fef3c7', color: '#ca8a04' },
  { keys: ['mẹ & bé', 'mẹ bé', 'baby'], icon: 'el-icon-present', bg: '#fce7f3', color: '#ec4899' },
  { keys: ['thú cưng', 'thú y', 'pet'], icon: 'el-icon-orange', bg: '#ffedd5', color: '#c2410c' },
  { keys: ['logistics', 'vận chuyển'], icon: 'el-icon-truck', bg: '#e0f2fe', color: '#0284c7' },
  { keys: ['bán lẻ', 'retail'], icon: 'el-icon-shopping-cart-2', bg: '#dcfce7', color: '#16a34a' },
  { keys: ['dịch vụ chuyên', 'professional'], icon: 'el-icon-suitcase', bg: '#f1f5f9', color: '#475569' },
  { keys: ['marketing', 'agency'], icon: 'el-icon-data-analysis', bg: '#fef3c7', color: '#d97706' },
  { keys: ['tài chính', 'bảo hiểm', 'finance', 'insurance'], icon: 'el-icon-bank-card', bg: '#ecfeff', color: '#0891b2' },
  { keys: ['sản xuất', 'manufactur'], icon: 'el-icon-setting', bg: '#e5e7eb', color: '#374151' },
  { keys: ['nông nghiệp', 'agriculture'], icon: 'el-icon-sunny', bg: '#dcfce7', color: '#15803d' },
  { keys: ['khách sạn', 'du lịch', 'travel', 'hotel'], icon: 'el-icon-place', bg: '#e0f2fe', color: '#0369a1' },
];
const INDUSTRY_ICON_FALLBACK = { icon: 'el-icon-more', bg: '#f3f4f6', color: '#4b5563' };

const FIELD_TYPE_LABELS = {
  Text: 'Văn bản',
  Number: 'Số',
  Date: 'Ngày',
  SingleSelect: 'Lựa chọn',
  MultiSelect: 'Nhiều lựa chọn',
  Array: 'Mảng',
  ArrayNumber: 'Mảng số',
};

const TAG_OVERRIDES = { storage: 'Nguồn khách' };

export default {
  name: "OnBoarding",
  components: { DialogCreateField, DialogCreateProcess, DialogUpdateProcess },

  props: {
    initialBusinessInfo: { type: Object, default: null },
  },

  data() {
    return {
      // Stepper
      currentStep: 1,

      // Step 1 — industries
      industries: [],
      customerTypeOptions: [],
      loadingIndustries: false,
      selectedIndustry: null,
      savingIndustry: false,
      latestBusinessInfo: null,
      industryIconMap: INDUSTRY_ICON_MAP,
      industryIconFallback: INDUSTRY_ICON_FALLBACK,

      // Step 2 — fields
      suggestedFields: [],
      loadingSuggestions: false,
      showSuggestionBanner: false,
      fieldsNeedRegenerate: false,
      currentFieldTab: 'all',
      deletingFieldId: null,

      // Step 3 — processes
      suggestedProcesses: [],
      loadingProcessSuggestions: false,
      showProcessSuggestionBanner: false,
      processesNeedRegenerate: false,
      currentProcessTab: 'all',

      // Dialogs
      showFieldDialog: false,
      showProcessDialog: false,
      showUpdateProcessDialog: false,
      pendingFieldInitial: null,
      pendingProcessInitial: null,
      editingProcess: null,

      // Finish dialog
      showSuccessDialog: false,
      countdown: 5,
      countdownTimer: null,
    };
  },

  computed: {
    isAdmin() {
      return this.app?.user?.type === 'ADMIN';
    },

    // --- Step 1: industry ---
    selectedIndustryName() {
      const found = this.industries.find(i => i.code === this.selectedIndustry);
      return found ? (found.display || found.name) : '';
    },

    // --- Step 2: fields ---
    codeRemain() {
      if (!this.app?.columnListAll || !this.app?.codes) return [];
      const existCode = this.app.columnListAll.map(c => c.name);
      return this.app.codes.filter(code => !existCode.includes(code));
    },
    allFields() {
      const cols = this.app.columnListAll || [];
      const codePool = new Set(this.app.codes || []);
      return cols.map(c => {
        const isCustom = codePool.has(c.name);
        const isAi = c.source === 'AI';
        let source = 'default';
        let tag = TAG_OVERRIDES[c.name] || 'Mặc định';
        if (isCustom) {
          if (isAi) { source = 'AI'; tag = 'AI đề xuất'; }
          else { source = 'USER'; tag = 'Tự tạo'; }
        }
        return {
          key: `f-${c.id || c.name}`,
          id: c.id || null,
          name: c.title || c.name,
          type: this.fieldTypeLabel(c.columnType),
          tag,
          source,
        };
      });
    },
    aiFieldCount()      { return this.allFields.filter(f => f.source === 'AI').length; },
    manualFieldCount()  { return this.allFields.filter(f => f.source === 'USER').length; },
    defaultFieldCount() { return this.allFields.filter(f => f.source === 'default').length; },
    fieldTabs() {
      return [
        { key: 'all',    label: 'Tất cả',     count: this.allFields.length },
        { key: 'ai',     label: 'AI đề xuất', count: this.aiFieldCount },
        { key: 'manual', label: 'Tự tạo',     count: this.manualFieldCount },
      ];
    },
    filteredFields() {
      if (this.currentFieldTab === 'ai')     return this.allFields.filter(f => f.source === 'AI');
      if (this.currentFieldTab === 'manual') return this.allFields.filter(f => f.source === 'USER');
      return this.allFields;
    },

    // --- Step 3: processes ---
    defaultProcess() {
      return (this.app?.processList || []).find(p => p.type === 'DEFAULT') || null;
    },
    otherProcesses() {
      return (this.app?.processList || []).filter(p => p.type !== 'DEFAULT' && p.id !== 'all');
    },
    aiProcessList()     { return this.otherProcesses.filter(p => p.source === 'AI'); },
    manualProcessList() { return this.otherProcesses.filter(p => p.source === 'USER'); },
    processTabs() {
      const total = (this.defaultProcess ? 1 : 0) + this.otherProcesses.length;
      return [
        { key: 'all',    label: 'Tất cả',     count: total },
        { key: 'ai',     label: 'AI đề xuất', count: this.aiProcessList.length },
        { key: 'manual', label: 'Tự tạo',     count: this.manualProcessList.length },
      ];
    },
    filteredOtherProcesses() {
      if (this.currentProcessTab === 'ai')     return this.aiProcessList;
      if (this.currentProcessTab === 'manual') return this.manualProcessList;
      return this.otherProcesses;
    },
  },

  watch: {
    currentStep(newStep, oldStep) {
      if (newStep === 2 && oldStep === 3) this.maybeLoadSuggestions();
      if (newStep === 1 && oldStep !== 1) this.refreshBusinessInfo();
    },
    selectedIndustry(newVal, oldVal) {
      if (oldVal && newVal && newVal !== oldVal) {
        this.fieldsNeedRegenerate = true;
        this.processesNeedRegenerate = true;
      }
    },
  },

  created() {
    this.fetchIndustries();
    this.refreshBusinessInfo();
  },

  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);
  },

  methods: {
    // =============================================================
    // Navigation
    // =============================================================
    async nextStep() {
      if (this.currentStep >= 3) return;
      if (this.currentStep === 1) {
        if (!this.selectedIndustry) return;
        this.currentStep = 2;
        this.saveIndustry();
        this.maybeLoadSuggestions();
        return;
      }
      if (this.currentStep === 2) {
        this.currentStep = 3;
        this.maybeLoadProcessSuggestions();
        return;
      }
      this.currentStep++;
    },
    prevStep() {
      if (this.currentStep > 1) this.currentStep--;
    },
    async skipOnboarding() {
      try {
        await HTTP.post('/api/ai-business', {
          companyCode: this.app.user.companyCode,
          userId: this.app.user.id,
          industry: JSON.stringify({ industry: [], businessSize: '', industryDetails: '' }),
          companyInfo: JSON.stringify({ description: '', aiModel: '' }),
          customerSegment: JSON.stringify({ customerTypes: [], customerSegment: '', customerDescription: '' }),
          targetByProcess: JSON.stringify([]),
          isSkip: true,
        });
      } catch (e) { /* silent */ }
      this.app.showOnboarding = false;
    },
    finishSetup() {
      this.showSuccessDialog = true;
      this.startCountdown();
    },
    startCountdown() {
      this.countdown = 5;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) this.goToDestination();
      }, 1000);
    },
    goToDestination() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.showSuccessDialog = false;
      this.app.showOnboarding = false;
      this.$router.push(this.isAdmin ? '/dashboard' : '/contact').catch(() => {});
    },

    // =============================================================
    // Step 1 — industries
    // =============================================================
    async fetchIndustries() {
      this.loadingIndustries = true;
      try {
        const res = await HTTP.get('/api/ai-business/common-data');
        if (res?.data) {
          const data = JSON.parse(res.data).data?.data || {};
          this.industries = Array.isArray(data.industry) ? data.industry : [];
          this.customerTypeOptions = Array.isArray(data.customerType) ? data.customerType : [];
        }
      } catch (e) {
        this.industries = [];
        this.customerTypeOptions = [];
      } finally {
        this.loadingIndustries = false;
        this.applyInitialIndustry();
      }
    },
    async refreshBusinessInfo() {
      try {
        const res = await HTTP.get('/api/ai-business', {
          params: { companyCode: this.app.user.companyCode, userId: this.app.user.id },
        });
        if (!res?.data) return;
        const root = JSON.parse(res.data).data?.data || {};
        this.latestBusinessInfo = root.aiBusinessInfo || null;
        this.applyInitialIndustry();
      } catch (e) { /* silent */ }
    },
    applyInitialIndustry() {
      const info = this.latestBusinessInfo || this.initialBusinessInfo;
      const code = info?.industry?.industry?.[0]?.code;
      if (code && this.industries.some(i => i.code === code)) {
        this.selectedIndustry = code;
      }
    },
    industryStyle(industry) {
      const haystack = `${industry.display || ''} ${industry.name || ''} ${industry.code || ''}`.toLowerCase();
      return this.industryIconMap.find(m => m.keys.some(k => haystack.includes(k))) || this.industryIconFallback;
    },
    buildBusinessPayload() {
      const industryOpt = this.industries.find(o => o.code === this.selectedIndustry);
      const customerTypeOpt = industryOpt
        ? this.customerTypeOptions.find(c => c.code === industryOpt.customer_type)
        : null;
      return {
        companyCode: this.app.user.companyCode,
        userId: this.app.user.id,
        industry: JSON.stringify({
          industry: industryOpt ? [{ code: industryOpt.code, display: industryOpt.display }] : [],
          businessSize: industryOpt?.business_size || '',
          industryDetails: industryOpt?.description || '',
        }),
        companyInfo: JSON.stringify({ description: '', aiModel: '' }),
        customerSegment: JSON.stringify({
          customerTypes: customerTypeOpt ? [{ code: customerTypeOpt.code, display: customerTypeOpt.display }] : [],
          customerSegment: '',
          customerDescription: industryOpt?.ideal_customer_profile || '',
        }),
        targetByProcess: JSON.stringify([]),
      };
    },
    async saveIndustry() {
      if (!this.selectedIndustry) return false;
      this.savingIndustry = true;
      try {
        await HTTP.post('/api/ai-business', this.buildBusinessPayload());
        return true;
      } catch (e) {
        console.error('saveIndustry failed', e);
        return false;
      } finally {
        this.savingIndustry = false;
      }
    },

    // =============================================================
    // AI suggestions — shared parsing
    // =============================================================
    parseGeneratedResponse(res, type) {
      let payload = res?.data;
      if (typeof payload === 'string') {
        try { payload = JSON.parse(payload); } catch (e) { /* keep as is */ }
      }
      const inner = payload?.data?.data ?? payload?.data ?? payload;
      // Single record (POST generate)
      if (inner && !Array.isArray(inner) && (inner.type || inner.result !== undefined)) {
        return this.extractResultList(inner.result, type);
      }
      // Array of records (GET cached)
      if (Array.isArray(inner)) {
        const matching = inner.filter(r => !type || r.type === type);
        const latest = matching
          .filter(r => r.result)
          .sort((a, b) => (b.updateAt || 0) - (a.updateAt || 0))[0];
        return latest ? this.extractResultList(latest.result, type) : [];
      }
      // Fallback: direct {fields|processes} shape
      const root = inner || {};
      return type === 'field' ? (root.fields || []) : (root.processes || root.fields || []);
    },
    extractResultList(result, type) {
      if (!result) return [];
      let parsed = result;
      if (typeof parsed === 'string') {
        try { parsed = JSON.parse(parsed); } catch (e) { return []; }
      }
      if (Array.isArray(parsed)) return parsed;
      const root = parsed?.data || parsed || {};
      return type === 'field' ? (root.fields || []) : (root.processes || root.fields || []);
    },
    async fetchExistingGenerated(type) {
      try {
        const res = await HTTP.get('/api/ai-business/generated-fields', {
          params: { companyCode: this.app.user.companyCode, type },
        });
        const list = this.parseGeneratedResponse(res, type);
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    },

    // =============================================================
    // Step 2 — field suggestions + tab list
    // =============================================================
    fieldTypeLabel(type) {
      return FIELD_TYPE_LABELS[type] || type;
    },
    isFieldAdded(sf) {
      const title = (sf.name || '').trim().toLowerCase();
      if (!title) return false;
      return (this.app.columnListAll || []).some(c => (c.title || '').trim().toLowerCase() === title);
    },
    mapFieldSuggestion(f) {
      const type = f.columnType || f.type || 'Text';
      return {
        name: f.columnTitle || f.name || f.title || f.display || '',
        type,
        typeLabel: this.fieldTypeLabel(type),
        selectOptions: Array.isArray(f.selectOptions) ? f.selectOptions : [],
        raw: f,
      };
    },
    async maybeLoadSuggestions() {
      if (!this.selectedIndustry) return;
      this.showSuggestionBanner = true;
      this.loadingSuggestions = true;
      this.suggestedFields = [];
      try {
        let list = this.fieldsNeedRegenerate ? [] : await this.fetchExistingGenerated('field');
        if (!list.length) {
          const res = await HTTP.post(
            '/api/ai-business/generate-fields',
            this.buildBusinessPayload(),
            { params: { type: 'field' } },
          );
          list = this.parseGeneratedResponse(res, 'field');
        }
        this.suggestedFields = list.map(f => this.mapFieldSuggestion(f));
        this.fieldsNeedRegenerate = false;
      } catch (e) {
        this.suggestedFields = [];
      } finally {
        this.loadingSuggestions = false;
      }
    },
    sourcePillClass(field) {
      if (field.source === 'AI')   return 'source-AI';
      if (field.source === 'USER') return 'source-manual';
      if (field.tag && field.tag !== 'Mặc định') return 'source-tagged';
      return 'source-default';
    },
    async removeField(item) {
      if (!item.id) return;
      this.deletingFieldId = item.id;
      try {
        await field.deleteColumns(item.id);
        this.$set(this.app, 'columnListAll', (this.app.columnListAll || []).filter(c => c.id !== item.id));
      } catch (e) {
        this.$message.error('Xóa trường thất bại');
      } finally {
        this.deletingFieldId = null;
      }
    },

    // =============================================================
    // Step 3 — process suggestions + tab list
    // =============================================================
    isProcessAdded(proc) {
      const name = (proc.processName || '').trim().toLowerCase();
      if (!name) return false;
      return (this.app.processList || []).some(p => (p.name || '').trim().toLowerCase() === name);
    },
    normalizeProcessSuggestion(p) {
      const rawSteps = p.workflowDTOS || p.workflowList || p.steps || p.workflows || [];
      const steps = rawSteps.map((s, i) => ({
        index: i + 1,
        title: s.title || s.name || '',
        milestoneType: s.milestoneType || s.type || 'OPEN',
        color: s.color || '#0A58C0',
        columnList: Array.isArray(s.columnList) ? s.columnList : ['displayName', 'phone'],
      }));
      // Mark last as WON if no explicit milestone set
      if (steps.length && !steps.some(s => s.milestoneType === 'WON')) {
        steps[steps.length - 1].milestoneType = 'WON';
      }
      return {
        processName: p.processName || p.name || p.title || '',
        processDescription: p.processDescription || p.description || '',
        workflowDTOS: steps,
      };
    },
    async maybeLoadProcessSuggestions() {
      if (!this.selectedIndustry) return;
      this.showProcessSuggestionBanner = true;
      this.loadingProcessSuggestions = true;
      this.suggestedProcesses = [];
      try {
        let list = this.processesNeedRegenerate ? [] : await this.fetchExistingGenerated('process');
        if (!list.length) {
          const res = await HTTP.post(
            '/api/ai-business/generate-fields',
            this.buildBusinessPayload(),
            { params: { type: 'process' } },
          );
          list = this.parseGeneratedResponse(res, 'process');
        }
        this.suggestedProcesses = (Array.isArray(list) ? list : []).map(p => this.normalizeProcessSuggestion(p));
        this.processesNeedRegenerate = false;
      } catch (e) {
        this.suggestedProcesses = [];
      } finally {
        this.loadingProcessSuggestions = false;
      }
    },

    // =============================================================
    // Dialogs — field
    // =============================================================
    openCreateFieldDialog() {
      this.pendingFieldInitial = null;
      this.showFieldDialog = true;
    },
    openFieldFromSuggestion(sf) {
      const nextCode = this.codeRemain[0] || null;
      this.pendingFieldInitial = {
        title: sf.name,
        columnType: sf.type,
        name: nextCode,
        aiAnalysis: false,
        source: 'AI',
        selectOptions: (sf.selectOptions || []).map((o, i) => ({
          id: i + 1,
          value: o.label,
          showColors: false,
        })),
      };
      this.showFieldDialog = true;
    },
    closeFieldDialog() {
      this.showFieldDialog = false;
      this.pendingFieldInitial = null;
      this.cleanupModals();
    },
    handleFieldDialogClose(newField) {
      if (newField && newField.title) {
        this.currentFieldTab = newField.source === 'AI' ? 'ai' : 'manual';
      }
      this.showFieldDialog = false;
      this.cleanupModals();
    },

    // =============================================================
    // Dialogs — process
    // =============================================================
    openCreateProcessDialog() {
      this.pendingProcessInitial = null;
      this.showProcessDialog = true;
    },
    openProcessFromSuggestion(proc) {
      this.pendingProcessInitial = {
        processName: proc.processName,
        processDescription: proc.processDescription,
        workflowDTOS: proc.workflowDTOS,
        source: 'AI',
      };
      this.showProcessDialog = true;
    },
    closeProcessDialog() {
      this.showProcessDialog = false;
      this.pendingProcessInitial = null;
      this.cleanupModals();
    },
    handleProcessDialogClose(formData) {
      if (formData && formData.processName) {
        this.currentProcessTab = formData.source === 'AI' ? 'ai' : 'manual';
      }
      this.showProcessDialog = false;
      this.pendingProcessInitial = null;
      this.cleanupModals();
      this.refreshProcessList();
    },
    openEditProcess(proc) {
      this.editingProcess = proc;
      this.showUpdateProcessDialog = true;
    },
    closeUpdateProcessDialog() {
      this.showUpdateProcessDialog = false;
      this.editingProcess = null;
      this.cleanupModals();
    },
    handleUpdateDefaultSuccess() {
      this.showUpdateProcessDialog = false;
      this.editingProcess = null;
      this.cleanupModals();
      this.refreshProcessList();
    },
    refreshProcessList() {
      const root = this.$root && this.$root.getProcessList ? this.$root : this.$parent;
      if (root && root.getProcessList) root.getProcessList();
    },
    cleanupModals() {
      this.$nextTick(() => {
        const container = this.$el;
        if (container) container.querySelectorAll('.v-modal').forEach(m => m.remove());
        document.querySelectorAll('body > .v-modal').forEach(m => m.remove());
      });
    },
  },
};
</script>

<style scoped>
.industry-card {
  border-width: 1.5px;
  border-color: #e5e7eb;
}

.industry-card:hover {
  border-color: #93c5fd;
  background-color: #f8fafc;
}

.industry-card.selected {
  border-color: #2563eb;
  background-color: #eff6ff;
  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.1);
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter {
  opacity: 0;
  transform: translateX(15px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(-15px);
}

.process-step {
  display: inline-block;
  padding: 6px 12px;
  background-color: #e1edfd;
  color: #176ad7;
  border: 1px solid #85b1ff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
}

.process-step.success {
  background-color: #e6f7eb;
  color: #1e8e3e;
  border-color: #5bb974;
}

.process-step.danger {
  background-color: #ffeced;
  color: #d93025;
  border-color: #f28b82;
}

.industry-grid-scroll {
  flex: 1 1 auto;
  min-height: 0;
  max-height: 550px;
  overflow-y: auto;
  overflow-x: hidden;
}

.industry-grid-scroll::-webkit-scrollbar {
  width: 6px;
}

.industry-grid-scroll::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 4px;
}

.industry-grid-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.ai-suggestion-banner {
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.step-footer {
  flex-shrink: 0;
  background: #fff;
  z-index: 2;
}

.process-suggestions-list,
.field-suggestions-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  max-height: 500px;
}

.process-suggestions-list::-webkit-scrollbar,
.field-suggestions-scroll::-webkit-scrollbar {
  width: 6px;
}

.process-suggestions-list::-webkit-scrollbar-thumb,
.field-suggestions-scroll::-webkit-scrollbar-thumb {
  background-color: #c7d2fe;
  border-radius: 4px;
}

.process-suggestions-list::-webkit-scrollbar-track,
.field-suggestions-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.onboarding-two-col {
  display: flex;
  gap: 20px;
  min-height: 0;
  overflow: hidden;
}

.onboarding-two-col .col-left {
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.onboarding-two-col .col-right {
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}

@media (max-width: 1100px) {
  .onboarding-two-col {
    flex-direction: column;
    overflow-y: auto;
  }
  .onboarding-two-col .col-left,
  .onboarding-two-col .col-right {
    flex: 1 1 auto;
    overflow: visible;
  }
}

.suggestion-chip {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background: #fff;
  border: 1px solid #c7d2fe;
  border-radius: 999px;
  font-size: 13px;
  color: #1e3a8a;
  cursor: pointer;
  transition: all 0.15s ease;
  user-select: none;
}

.suggestion-chip:hover {
  border-color: #4f46e5;
  background: #eef2ff;
}

.suggestion-chip.selected {
  background: #4f46e5;
  border-color: #4f46e5;
  color: #fff;
}

.suggestion-chip.added {
  background: #ecfdf5;
  border-color: #6ee7b7;
  color: #047857;
  cursor: default;
}

.suggestion-chip.added:hover {
  background: #ecfdf5;
  border-color: #6ee7b7;
}

.chip-badge {
  background: #10b981;
  color: #fff;
  border-radius: 999px;
  padding: 1px 8px;
  font-size: 10px;
  font-weight: 600;
}

.process-suggestion-card.added {
  background: #ecfdf5;
  border-color: #6ee7b7;
  cursor: default;
}

.process-suggestion-card.added:hover {
  background: #ecfdf5;
  border-color: #6ee7b7;
}

.suggestion-chip .chip-type {
  font-size: 11px;
  opacity: 0.75;
}

.option-editor-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
}

.option-pill {
  display: inline-flex;
  align-items: center;
  background: #eef2ff;
  color: #1e3a8a;
  border: 1px solid #c7d2fe;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 12px;
}

.option-input {
  border: 1px dashed #c7d2fe;
  background: transparent;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 12px;
  color: #1f2937;
  min-width: 180px;
  outline: none;
}

.option-input::placeholder {
  color: #94a3b8;
}

.option-input:focus {
  border-style: solid;
  border-color: #4f46e5;
}

.field-tab {
  background: transparent;
  border: none;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.15s ease;
}

.field-tab:hover {
  background: #eef2ff;
  color: #1e3a8a;
}

.field-tab.active {
  background: #2563eb;
  color: #fff;
}

.field-tab-count {
  background: #f1f5f9;
  color: #64748b;
  border-radius: 999px;
  padding: 1px 8px;
  font-size: 11px;
  font-weight: 700;
  min-width: 20px;
  text-align: center;
}

.field-tab.active .field-tab-count {
  background: #ffffff;
  color: #2563eb;
}

.field-check {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.field-check.check-default {
  background: #e2e8f0;
  color: #94a3b8;
}

.field-check.check-AI {
  background: #c7d2fe;
  color: #4f46e5;
}

.field-check.check-USER {
  background: #bfdbfe;
  color: #2563eb;
}

.type-pill {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
}

.source-pill {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.source-pill.source-default {
  background: #f1f5f9;
  color: #64748b;
}

.source-pill.source-AI {
  background: #e0e7ff;
  color: #4338ca;
}

.source-pill.source-manual {
  background: #dbeafe;
  color: #1d4ed8;
}

.source-pill.source-tagged {
  background: #2563eb;
  color: #ffffff;
}

.process-suggestion-card {
  background: #fff;
  border: 1px solid #c7d2fe;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.15s ease;
  color: #1e3a8a;
}

.process-suggestion-card:hover {
  border-color: #4f46e5;
  background: #eef2ff;
}

.process-suggestion-card.selected {
  background: #eef2ff;
  border-color: #4f46e5;
  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.15);
}

.process-steps-editor {
  border-top: 1px dashed #c7d2fe;
  margin-top: 8px;
  padding-top: 8px;
}

.step-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #c7d2fe;
  color: #1e3a8a;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.step-input {
  border: 1px solid transparent;
  background: #fff;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 12px;
  color: #1f2937;
  outline: none;
  transition: border-color 0.15s ease;
  min-width: 200px !important;
}

.step-input:hover {
  border-color: #e2e8f0;
}

.step-input:focus {
  border-color: #4f46e5;
}

.step-remove {
  cursor: pointer;
  color: #94a3b8;
  font-size: 14px;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.15s ease;
}

.step-remove:hover {
  color: #dc2626;
  background: #fee2e2;
}

.color-dot {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px #cbd5e1;
  transition: transform 0.1s ease;
  flex-shrink: 0;
}

.color-dot:hover {
  transform: scale(1.1);
}

.color-dot.active {
  box-shadow: 0 0 0 2px #4f46e5;
}

.color-square {
  display: inline-block;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #cbd5e1;
  transition: transform 0.1s ease;
  flex-shrink: 0;
}

.color-square:hover {
  transform: scale(1.08);
}

.color-square.active {
  border: 2px solid #4f46e5;
  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.2);
}

.color-square.color-swatch {
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);
}

.fields-list-scroll {
  height: 302px;
  overflow-y: auto;
  padding-right: 4px;
}

.process-list-scroll {
  height: 420px;
  overflow-y: auto;
  padding-right: 4px;
}

.fields-list-scroll::-webkit-scrollbar,
.process-list-scroll::-webkit-scrollbar {
  width: 6px;
}

.fields-list-scroll::-webkit-scrollbar-thumb,
.process-list-scroll::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 4px;
}

.fields-list-scroll::-webkit-scrollbar-track,
.process-list-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.hover-light:hover {
  background-color: #dbeafe !important;
}

::v-deep .onboarding-success {
  border-radius: 16px !important;
  overflow: hidden;
}

::v-deep .onboarding-success .el-dialog__header {
  display: none !important;
}

::v-deep .onboarding-success .el-dialog__body {
  padding: 36px !important;
}
</style>

<style>
/* Ensure all Element UI popups appear above onboarding (z-index 3000) */
.el-message {
  z-index: 3500 !important;
}
.el-message-box__wrapper {
  z-index: 3500 !important;
}
.el-select-dropdown {
  z-index: 3500 !important;
}
.el-dropdown-menu {
  z-index: 3500 !important;
}
.el-popover {
  z-index: 3500 !important;
}
.el-popper {
  z-index: 3500 !important;
}
</style>
